
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.67 22.73"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.17 0H.5.44c-.03 0-.06 0-.1.02H.3C.28.02.27.04.25.05.22.07.19.08.17.1c0 0-.02.01-.03.02C.13.13.12.15.11.17.09.2.07.22.05.25.03.28.02.31.02.34.02.36 0 .37 0 .39v18.46c0 .04.01.07.02.11 0 .03 0 .06.02.08.01.03.03.05.05.08.02.03.03.06.06.08.02.02.05.03.07.05.03.02.06.04.1.06h.01l9.49 3.36a.47.47 0 00.43-.05c.02-.01.03-.02.05-.03.07-.06.13-.13.16-.21 0-.03 0-.05.01-.08 0-.03.02-.05.02-.08v-1.54h2.81c.28 0 .5-.22.5-.5v-1.29h2.37c.28 0 .5-.22.5-.5V.5c0-.28-.22-.5-.5-.5zM9.49 21.52l-8.49-3V1.26l8.49 3.61v16.65zm1-16.98v-.01c0-.06-.01-.12-.04-.18-.01-.03-.04-.06-.05-.08-.02-.03-.03-.05-.05-.08a.419.419 0 00-.16-.11l-5.63-2.4 8.24 1.37v16.63h-2.31V4.53zm3.3-1.96s0-.07-.02-.1c-.01-.03-.02-.06-.04-.09s-.03-.05-.05-.08a.234.234 0 00-.07-.07.218.218 0 00-.08-.05c-.03-.02-.06-.03-.09-.04-.02 0-.03-.02-.05-.02L6.56.99h9.12v16.89h-1.87V2.63s0-.04-.01-.06z","data-name":"Layer 1"}})])
          )
        }
      }
    